module.exports = __webpack_public_path__ + "img/process-img.b4d9a440.png";